module.exports = __webpack_public_path__ + "img/testimonial-carol-rose.d4cd94cd.png";